import { render } from "./tipologiaForm.vue?vue&type=template&id=ca9af276&scoped=true"
import script from "./tipologiaForm.vue?vue&type=script&lang=js"
export * from "./tipologiaForm.vue?vue&type=script&lang=js"

import "./tipologiaForm.vue?vue&type=style&index=0&id=ca9af276&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca9af276"]])

export default __exports__